import changeSelectedFileProvider from '../actions/changeSelectedFileProvider';
import getAddedProviders from '../utils/getAddedProviders';
import { fileProviderAdded } from 'owa-fileprovider-store';
import { FileProviderViewState } from 'owa-fileprovider-store';
import { getFilePickerStore } from '../store/filePickerStore';
import { orchestrator } from 'satcheljs';

orchestrator(fileProviderAdded, actionMessage => {
    fileProviderAddedOrchestrator(actionMessage.providerViewState);
});

export default function fileProviderAddedOrchestrator(newProviderViewState: FileProviderViewState) {
    const viewState = getFilePickerStore().viewState;
    // Get new providers and update the list that is displayed to the user
    const providersViewState: FileProviderViewState[] = getAddedProviders();
    const [fileProviderViewState] = providersViewState.filter(
        provider => provider.model.Id === newProviderViewState.model.Id
    );
    // Change to the selected provider
    changeSelectedFileProvider(fileProviderViewState, viewState);
}
